module.exports = __webpack_public_path__ + "img/20_63.40ff973f.png";